import { Button } from 'entities/Button'
import { checkPaymentHealth } from './checkPaymentHealth'
import { useState } from 'react'
import { consoleError } from 'shared/helpers/consoleError'

export const PaymentHealthCheckButton = () => {
  const [isLoading, setIsLoading] = useState(false)
  const checkHealthInner = async () => {
    try {
      setIsLoading(true)
      await checkPaymentHealth()
    } catch (e) {
      consoleError(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button width='100%' isLoading={isLoading} handleClick={checkHealthInner}>
      Check credentials
    </Button>
  )
}
